<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="130px"
    >
      <el-form-item label="选择公众号">
        <div class="chjoawew">
          <el-tag
            v-for="itemr, index in appidarr"
            :key="index"
            style="margin-right:10px;margin-bottom:5px"
            closable
            @close="rightclick(itemr.app_id, index)"
          >
            {{ itemr.account_name }}
          </el-tag>
          <el-button
            type="primary"
            size="mini"
            @click="chooser"
          >选择公众号</el-button>
        </div>

      </el-form-item>
      <el-form-item>
        <el-button
          type="success"
          @click="jdaweq"
        >确定</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      :title="'绑定公众号'"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :append-to-body="true"
      width="50%"
    >
      <bandstaff
        ref="bandstaffview"
        @updatawe="updatawe"
      />
    </el-dialog>
  </div>
</template>

<script>
import bandstaff from './bandstaff.vue'
import { adaudiencebind } from '@/api/providerAccountManagement/servicePorviderList.js'
export default {
  components: { bandstaff },
  data() {
    return {
      labelPosition: 'right',
      dialogVisible: false,
      appidarr: [],
      chuanarr: [],
      id: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(type, item) {
      console.log(item)
      this.id = item.id
      this.appidarr = []
      this.appidarr = item.yw_open_app.map(({ app_name, ...rest }) => ({
        ...rest,
        account_name: app_name
      }))
    },
    chooser() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.appidarr)
      })
    },
    updatawe(appidarr) {
      this.dialogVisible = false
      this.appidarr = []
      this.appidarr = appidarr
    },
    rightclick(app_id, index) {
      this.appidarr.splice(index, 1)
    },
    jdaweq() {
      // if (this.appidarr.length === 0) {
      //   this.$message({
      //     message: '请选择公众号',
      //     type: 'error'
      //   })
      // }
      this.chuanarr = []
      this.chuanarr = this.appidarr.map(item => {
        return item.app_id
      })
      adaudiencebind({
        id: this.id,
        bind_app: this.chuanarr
      }).then(res => {
        this.$emit('updatawe')
        this.$message({
          message: '绑定成功',
          type: 'success'
        })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.chjoawew {
  max-height: 400px;
  overflow-y: auto;
}
</style>
